import * as R from 'ramda';
import { DAY_MILLIS, HOUR_MILLIS } from '../config/constants';
import { parseNumber, round } from './number.utils';

export interface TimeDetail {
  hours: number;
  minutes: number;
  seconds: number;
}

export const getTimeDetail = (time: number): TimeDetail => {
  const totalSeconds = Math.floor(time / 1000);
  const totalMinutes = Math.floor(totalSeconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const seconds = totalSeconds % 60;

  return { hours, minutes, seconds };
};

export const getTimeFormat = R.curry((format = '{HOURS}:{MINS}', time: number) => {
  const timeDetail = getTimeDetail(time);

  return format
    .replace('{HOURS}', timeDetail.hours.toString())
    .replace('{MINS}', timeDetail.minutes.toString().padStart(2, '0'))
    .replace('{SECS}', timeDetail.seconds.toString().padStart(2, '0'));
});

export const getTimeMillisFromString = (time: string) => {
  const splittedTime = time.split(':');
  const hours = parseNumber(splittedTime[0]);
  const minutes = parseNumber(splittedTime[1]);
  const seconds = parseNumber(splittedTime[2]);

  return ((hours * 60 + minutes) * 60  + seconds) * 1000;
};

export const getDaysFromTime = (time: number) => round(time / DAY_MILLIS);

export const getHoursFromTime = (time: number) => round(time / HOUR_MILLIS);

export const formatHour = (hour: number) => `${ hour.toString().padStart(2, '0') }:00`;

export const hoursToMillis = (time: number) => time * 60 * 60 * 1000;

export const minutesToMillis = (time: number) => time * 60 * 1000;

export const millisToHours = (time: number) => time / 60 / 60 / 1000;

export const millisToMinutes = (time: number) => time / 60 / 1000;

export const millisToSeconds = (millis: number) => millis / 1000;

export const secondsToMillis = (seconds: number) => seconds * 1000;



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/utils/time.utils.ts